import React from "react";
import classNames from "classnames";
import draggable from "fantastic/components/hoc/draggable";

const SectionEntity = ({ src }) => {

  const sectionClass = classNames('fantastic-elements__section', {
    'fantastic-elements__section--wait': !src
  });

  return <div className={sectionClass}>
    { src ? (
      <img src={src} />
    ) : (
      <span className="fantastic-elements__loading"/>
    ) }
  </div>;
};

export default draggable("SECTION")(SectionEntity);
